import React from 'react';
import MetaTags from 'react-meta-tags';
import { ReactTitle } from 'react-meta-tags';

class SeoConfig extends React.Component {

  /* 
  Sayfalar için cms den verilen custom degerleri bunlara gore seo ayarlamaları yapıldı kodlar yazıldı. Tek return yaptıgı ıcın performans olarak bigO 2n
  Modeller : 1
  Fiyat Listesi = 2
  Transporter Kombi = 3
  Transporter Panel Van = 4
  Transporter Pikap = 5
  CARAVELLE HİGHLİNE = 6
  CARAVELLE COMFORT = 7
  crafter servis 8
  crafter panel van 9
  crafter okul 10
  yol yardım 11
  bakım onarım 12
  mobilite hizmetleri 13
  style->15
life->16
impression->17
cargo->18
  */

  render() {

    if (this.props.custom == 1) {
      return (
        <div>
          <MetaTags>
            <ReactTitle title="Volkswagen Ticari Caddy, Transporter, Caravelle, Amarok ve Crafter 2021 Modelleri" />
            <meta name="description" content="Volkswagen ticari araç modelleri Volkswagen Caddy, Volkswagen Transporter, Volkswagen Caravelle, Volkswagen Amarok ve Volkswagen Crafter hakkında bilgi alın." />
          </MetaTags>
        </div>
      )
    }
    else if (this.props.custom == 2) {
      return (
        <div>
          <MetaTags>
            <ReactTitle title="Volkswagen Ticari 2021 Fiyat Listesi | Caddy, Transporter, Caravelle, Amarok, Crafter" />
            <meta name="description" content="Volkswagen ticari araç modelleri Volkswagen Caddy, Volkswagen Transporter, Volkswagen Caravelle, Volkswagen Amarok ve Volkswagen Crafter için 2021 yılı güncel sıfır anahtar teslim fiyat listesi." />
          </MetaTags>
        </div>)

    }
    else if (this.props.custom == 3) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Transporter Kombi 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volkswagen Transporter Kombi teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>)
    }
    else if (this.props.custom == 4) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Transporter Panel Van 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volkswagen Transporter Panel Van teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>)
    }
    else if (this.props.custom == 5) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Transporter Pikap 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volkswagen Transporter Pikap teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>)
    }
    else if (this.props.custom == 6) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Caravelle Highline 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volkswagen Caravelle Highline teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>)
    }
    else if (this.props.custom == 7) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Caravelle Comfortline 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volkswagen Caravelle Comfortline teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>)
    }

    else if (this.props.custom == 8) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Crafter Servis 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="Crafter Servis 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
        </MetaTags>
      </div>)
    }
    else if (this.props.custom == 9) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Crafter Panel Van 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volkswagen Crafter Panel Van teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>)
    }
    else if (this.props.custom == 10) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Crafter Okul 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volkswagen Crafter Okul teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>)
    }

    else if (this.props.custom == 11) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Volkswagen 7/24 Acil Yol Yardım Hizmeti| Volkswagen Ticari Araçlar" />
          <meta name="description" content="7/24 Volkswagen ticari aracınız için yol yardımı alabilirsiniz. Detaylı bilgi için tıklayın." />
        </MetaTags>
      </div>)
    }
    else if (this.props.custom == 12) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Volkswagen Ticari Araç Servis & Periyodik Bakımları | Volkswagen Ticari Araçlar" />
          <meta name="description" content="Volkswagen ticari aracınızın periyodik bakımları, yağ değişimleri ve yıllık bakım fiyatları hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>)
    }
    else if (this.props.custom == 13) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Volkswagen Ticari Araç Ekspres Servis | Volkswagen Ticari Araçlar" />
          <meta name="description" content="Ekspres Servis kapsamında servis işlemi beklemeden yerinden alım yerine teslim hakkında detaylı bilgi için tıklayın." />
        </MetaTags>
      </div>)
    }
    else if (this.props.custom == 14) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Volkswagen Ticari Araçlar | Modeller, Servis, Fiyat Listesi" />
          <meta name="description" content="Volkswagen Ticari Araçlar tavsiye edilen fiyat listesi ile kampanyalı anahtar teslim fiyatlarına, yetkili satıcı ve servis ağına ulaşmak için sitemizi ziyaret edebilirsiniz" />
        </MetaTags>
      </div>
      )
    }
    else if (this.props.custom == 15) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Caddy Style 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volskwagen Caddy Style teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>
      )
    }
    else if (this.props.custom == 16) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Caddy Life 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volskwagen Caddy Life teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>
      )
    }
    else if (this.props.custom == 17) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Caddy Impression 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volskwagen Caddy Impression teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>
      )
    }
    else if (this.props.custom == 18) {
      return (<div>
        <MetaTags>
          <ReactTitle title="Caddy Cargo 2021 Model Fiyatları & Özellikleri | Volkswagen Ticari Araçlar" />
          <meta name="description" content="2021 Model Volskwagen Caddy Cargo teknik özellikleri, fiyatları ve modelleri hakkında bilgi almak için tıklayın." />
        </MetaTags>
      </div>
      )
    }
  }


}

export default SeoConfig;
